// @flow

import React from "react";
import { localize } from "redux-i18n";
import type { FormProps } from "redux-form";

import { AbsenceMonitoringLevelsForm } from "./absence-monitoring-levels-form";
import type {
  AbsenceMonitoring,
  AbsenceMonitoringTask,
} from "@modules/service/reducer/absence-monitoring/types";
import type { AlertShort } from "@modules/shared/reducer/alerts/types";

type OwnProps = $Exact<{
  data: ?Array<AbsenceMonitoring>,
  alerts: ?Array<AlertShort>,
  tasks: ?Array<AbsenceMonitoringTask>,
  onChange?: (data: Array<AbsenceMonitoring>) => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export const AbsenceMonitoringLevelsView = (props: Props) => {
  const { data, ...rest } = props;

  return <AbsenceMonitoringLevelsForm {...rest} data={data.levels} readonly={true} />;
};

export default localize()(AbsenceMonitoringLevelsView);
